type Props = {
  icon?: React.ReactNode;
  step?: number;
  title: string | React.ReactNode;
  children?: React.ReactNode;
};

/**
 * Wrap in  <ol className="relative border-gray-300 border-s-2 border-dashed ml-2"> when using
 */
const TimelineItem = ({ icon, step, title, children }: Props) => {
  return (
    <li className="relative border-s-2 border-brand-primary pb-10 pl-10 last:border-s-0">
      <span className="absolute -start-4 flex h-8 w-8 -translate-x-[1px] items-center justify-center rounded-full bg-white text-sm font-medium text-brand-primary ring-2 ring-fg-brand-primary">
        {icon ?? step ?? "1"}
      </span>
      <h3 className="mb-1 flex items-center text-xl font-semibold text-primary">{title}</h3>
      {children && <div className={"text-sm text-quaternary"}>{children}</div>}
    </li>
  );
};

export default TimelineItem;
